import { StringifyTransformation } from 'app/model/dataflow/stringifytransformation';
import { ParseFormat } from 'app/model/dataflow/parsetransformation';
import { Transformation } from 'app/model/dataflow/transformation';
import { StringifyPlainObject } from 'worker/app-workers/shared/plainObjects/stringify.plainObject';
import { DataFlowExpressionUtils } from '../../expression.util';
import { SchemaModifierBaseConvertor } from './schemaModifierBase.convertor';
import { IResourceContext } from 'shell-models-lib';

export class StringifyConvertor extends SchemaModifierBaseConvertor {
    private get StringifyTransformation(): StringifyTransformation {
        return this.transformation as StringifyTransformation;
    }

    private get stringifyObject(): StringifyPlainObject {
        return this.transformObject as StringifyPlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        if (this.stringifyObject.configs.has('format')) {
            this._handledConfigs.push('format');
            this.StringifyTransformation.format = DataFlowExpressionUtils.extractStringConfigValue(
                this.stringifyObject.configs.get('format')
            ) as ParseFormat;
            const formatSettings =
                this.StringifyTransformation.format === ParseFormat.delimitedText
                    ? this.StringifyTransformation.delimitedTextSettings
                    : undefined;

            this.stringifyObject.configs.forEach((expression: string, configName: string) => {
                if (configName !== 'format') {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (formatSettings as any)[configName] = DataFlowExpressionUtils.extractStringConfigValue(expression);
                    if (configName === 'nullValue') {
                        formatSettings.nullValue = DataFlowExpressionUtils.unescapeBackslashInDslString(
                            formatSettings.nullValue
                        );
                    } else if (configName === 'columnNamesAsHeader') {
                        formatSettings.columnNamesAsHeader =
                            DataFlowExpressionUtils.extractStringConfigValue(expression) === 'true';
                    }
                    this._handledConfigs.push(configName);
                }
            });
        }
        await super.convert(contextData);
        return this.transformation;
    }
}
